import { render } from "./AllTransactions.vue?vue&type=template&id=81e8f4e4"
import script from "./AllTransactions.vue?vue&type=script&lang=js"
export * from "./AllTransactions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__